<!--
Author: TangChen
Date: 2018-11-06
Desc: 投资者信息补录，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="info">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info' }">信息中心</el-breadcrumb-item>
                <el-breadcrumb-item>投资者信息补录</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-info-collection bizcomp ' + className">
            <inv-info />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import invInfo from "@/components/acctInfo/invInfo.vue";
export default {
    name: "InfoCollection",
    components: {
        invInfo
    },
    mixins: [mixin],
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户信息 */
.bizcomp-info-collection {
    padding-bottom: 30px;
}
</style>
